import Loader from "react-loader-spinner";
import { Button, Card, Col, Form, InputGroup, Row, Table } from "react-bootstrap";
import { CardImage, CheckSquare, DashCircle, List, PlusSquareFill, Search } from "react-bootstrap-icons";
import { Fragment, useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ModalSelectProductGroup from "../Common/ModalSelectProductGroup";
import { addPreCustomerProducts, deletePreCustomerProduct, getCustomerProductList, getCustomerProductList_Local } from "../store/api/CustomerApi";

import { searchProductForSelect, setDialog } from "../store/api/GetAllProduct";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCommentAlt } from "@fortawesome/free-solid-svg-icons";
import BihamtaTable from "../Components/BihamtaTable";
import { getSystemSettings } from "../store/api/SystemSettingsAPI";
import ModalEnlargeImage from "../Components/ModalEnlargeImage";
import { getImageServerPath } from "../store/api/CommonFunctions";

const CustomerProducts = () => {
    const filterData = useRef({});
    const searchData = useRef({});
    const dispatch = useDispatch();
    const selectedProducts = useRef([]);
    const settingNames = ['ProductGrouppingType'];
    const [pending, setPending] = useState(false);
    const [submitError, setSubmitError] = useState({});
    const [selectedGroup, setGroupData] = useState({});
    const [showAddDiv, setShowAddDiv] = useState(false);
    const submitData = useRef({ UnitPrice: 0, Count: 1 });
    const [popImage, setPopImage] = useState({ show: false });
    const [popSelectProductGroup, setSelectProductGroupPop] = useState({ show: false });
    const { settings, productList, selectedProductList } = useSelector(state => {
        return {
            settings: state.SystemSettingsReducer.systemSettings,
            productList: state.customerDataReducer.customerProductList.Data,
            selectedProductList: state.customerDataReducer.selectedProductList
        }
    });
    const pgType = Number(settings?.find(s => s.SettingName === "ProductGrouppingType")?.SettingValue);

    const tableColes = [
        { colTitle: "ردیف", colName: "RowNumber", justInMobile: true },
        { colTitle: " گروه کالا", colName: "ProductGroupName", justInMobile: true },
        { colTitle: "نام کالا", colName: "ProductName", justInMobile: true },
        { colTitle: "تعداد", colName: "Count", justInMobile: true },
        { colTitle: "قیمت واحد", colName: "UnitPrice", justInMobile: false, colType: "currency" },
        { colTitle: "قیمت کل", colName: "TotalPrice", justInMobile: false, colType: "currency" },
        { colTitle: "توضیحات", colName: "Description", justInMobile: false, colType: "string", maxTextLength: 150 }
    ]
    const tableRowButtons = [{
        title: "حذف ردیف", type: "delete", className: "group-Btn-smalll btn-danger",
        onclick: (item) => dispatch(setDialog({
            status: 'show',
            arrayBtn: ['yes', 'no'],
            dialogTitle: 'حذف ردیف',
            dialogText: 'آیا از حذف مطمئن هستید؟',
            okOperation: deleteRow(item.ID)
        }))
    }];
    const showGroupModal = () => {
        const onSelectG = (group) => {
            if (!group || group.length == 0) {
                return;
            }
            setGroupData(group);
        }
        setSelectProductGroupPop({ show: true, onSelect: onSelectG, value: "" });
    }
    const add = () => {
        if (pending) {
            return;
        }
        const err = {};
        if (!Array.isArray(selectedProducts.current) || selectedProducts.current.length === 0) {
            err.ProductID = "انتخاب کالا الزامی است";
        }
        if (!selectedGroup.GroupID) {
            err.GroupID = "انتخاب گروه کالا الزامی است";
        }
        const data = [...selectedProducts.current];
        data.forEach(d => {
            d.Count = d.Count ?? 1;
            d.ProductGroupID = selectedGroup.GroupID;
        })
        setSubmitError(err);
        if (Object.keys(err).length > 0) {
            return;
        }
        const onSuccess = (res) => {
            setShowAddDiv(false);
            selectedProducts.current = [];
            setGroupData({});
            submitData.current = { UnitPrice: 0, Count: 1 };
            dispatch(getCustomerProductList_Local({ ...res }));
            setPending(false);
        }
        setPending(true);
        dispatch(addPreCustomerProducts(data, onSuccess));
    }
    const deleteRow = (id) => {
        return () => {
            const onSuccess = () => {
                const removed = productList.filter(p => p.ID !== id);
                dispatch(getCustomerProductList_Local({ Data: removed }));
            }
            dispatch(deletePreCustomerProduct(id, onSuccess));
        }
    }
    function hideAddDiv() {
        setSubmitError({});
        selectedProducts.current = [];
        setGroupData({});
        setShowAddDiv(false);
    }
    const select = (dt) => {
        // if (imageclicked) {
        //     imageclicked = false;
        //     return;
        // }
        const item = dt.item;
        var data = {};
        data.ProductID = item.ID;
        data.ProductName = item.Name;
        data.ProductModel = item.Model;
        data.HolderName = item.HolderName;
        data.UnitPrice = item.SalePrice ?? 0;
        data.Count = item.Count ?? 1;
        const checked = dt.currentTarget.checked;
        if (checked) {
            selectedProducts.current.push(data);
        }
        else if (selectedProducts.length > 0) {
            selectedProducts.current = selectedProducts.current.filter(s => Number(s.ProductID) !== Number(data.ProductID));
        }
    }
    function changeProductCount(id, e) {
        e.preventDefault();
        const found = selectedProducts.current.find(s => Number(s.ProductID) == Number(id));
        //For When Count Changes Before Check
        const product = selectedProductList.find(p => Number(p.ID) === Number(id));
        product.Count = Number(e.target.value);
        //
        if (found) {
            found.Count = Number(e.target.value);
        }
    }
    const search = (e) => {
        if (e.key && e.key !== "Enter") {
            return;
        }
        searchData.current.Take = 50;
        searchData.current.GroupID = selectedGroup.GroupID;
        selectedProducts.current = [];
        dispatch(searchProductForSelect(searchData.current));
    }
    function magnify(imageName) {
        const onSuccess = (res) => {
            if (res.FilePath) {
                setPopImage({ show: true, imageUrl: res.FilePath });
            }
        }
        if (imageName && imageName !== "") {
            getImageServerPath(imageName, onSuccess);
        }
    }
    useEffect(() => {
        document.body.classList = "notMain";
        dispatch(getSystemSettings(settingNames));
        dispatch(getCustomerProductList(0));
    }, [])
    return (
        <div className="container-fluid mt-2">
            <br />
            <Card style={{ textAlign: "right" }}>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faCommentAlt} size="lg" />
                    &nbsp;
                    <h6 style={{ display: "inline-block", margin: "auto" }}>محصولات درخواستی</h6>
                </Card.Header>
                <Card.Body className="bodyStyle">
                    <ModalEnlargeImage popData={popImage} setPopData={setPopImage} />
                    <ModalSelectProductGroup selectOne={true} setPopData={setSelectProductGroupPop} popData={popSelectProductGroup} />
                    {showAddDiv &&
                        <Row className="rowBorder" style={{ padding: "12px", margin: 0 }}>
                            <div className="rowTitle">انتخاب کالا</div>
                            <Row>
                                <Col md={2} className="form-group">
                                    <input type="text" className="form-control" value={selectedGroup.GroupName ?? ""} readOnly onKeyDown={showGroupModal} placeholder="گروه کالا" />
                                    <Button className="btn-input-tiny" onClick={showGroupModal} style={{ top: "10px" }}><List size={18} /></Button>
                                    {submitError?.GroupID && <small className="errors">{submitError.GroupID}</small>}
                                </Col>
                                {pgType !== 1 &&
                                    <Col md={3} className="form-group">
                                        <input type="text" placeholder="مارک کالا" className="form-control"
                                            onChange={e => searchData.current.HolderName = e.target.value}
                                            onKeyDown={search} />
                                    </Col>
                                }
                                <Col md={2} className="form-group">
                                    <input type="text" placeholder={(pgType === 1) ? ('نام کالا') : ('نوع کالا')} className="form-control"
                                        onChange={e => searchData.current.Name = e.target.value} onKeyDown={search} />
                                </Col>
                                <Col md={2} className="form-group">
                                    <input type="text" placeholder="مدل کالا" className="form-control"
                                        onChange={e => searchData.current.Model = e.target.value} onKeyDown={search} />
                                </Col>
                                <div className="mt-1">
                                    <Button variant="secondary" className="group-Btn-large" onClick={search}><Search size={15} />&nbsp; جستجوی کالا</Button>
                                </div>
                            </Row>
                            {window.innerWidth >= 414 &&
                                <Table className="mt-1 fixedTable" responsive={true}>
                                    <thead>
                                        <tr style={{ padding: "0" }}>
                                            <th style={{ width: "15%" }}>کد کالا</th>
                                            {pgType !== 1 && <th style={{ width: "15%" }} >مارک کالا</th>}
                                            <th style={{ width: pgType === 1 ? "25%" : "15%" }} >{pgType === 1 ? "نام کالا" : "نوع کالا"}</th>
                                            <th style={{ width: pgType === 1 ? "25%" : "20%" }} >مدل کالا</th>
                                            <th style={{ width: "10%" }}>قیمت واحد</th>
                                            <th style={{ textAlign: "center", width: "10%" }} title="تصویر کالا"><CardImage size={20} /></th>
                                            <th style={{ width: "15%" }}>تعداد کالای انتخابی</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            selectedProductList && selectedProductList === "PENDING" &&
                                            <tr><td colSpan={5 + (pgType !== 1 ? 1 : 0)} style={{ textAlign: "center", width: "100%" }}><Loader width={25} height={25} type="BallTriangle" color="#bb1370" /></td></tr>
                                        }
                                        {selectedProductList && selectedProductList.Error &&
                                            <tr><td colSpan={5 + (pgType !== 1 ? 1 : 0)} style={{ textAlign: "center", color: "red" }}>{selectedProductList.Error}</td></tr>
                                        }
                                        {selectedProductList && Array.isArray(selectedProductList) &&
                                            selectedProductList.map((item, i) => {
                                                return (
                                                    <tr key={i} className="resultTableRow">

                                                        <td style={{ width: "15%" }}>{item.KalaCode}</td>
                                                        {pgType !== 1 && <td style={{ width: "15%" }}>{item?.HolderName}</td>}
                                                        <td style={{ width: pgType === 1 ? "25%" : "15%" }}>{item?.Name}</td>
                                                        <td style={{ width: pgType === 1 ? "25%" : "20%" }}>{item?.Model}</td>
                                                        <td style={{ width: "10%" }}>{item.SalePrice?.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</td>
                                                        <td style={{ padding: "2px", width: "10%", cursor: item?.ProductImage ? "zoom-in" : "pointer" }} onClick={() => magnify(item?.ProductImageURL)}>
                                                            {item && item.ProductImage && <img src={"data:image;base64," + item?.ProductImage} atl='' style={{ height: "35px", display: "block", margin: "auto" }} />}
                                                        </td>
                                                        <td style={{ width: "15%" }}>
                                                            <InputGroup>
                                                                <input type='checkbox' className='form-check-input' onClick={(e) => select({ ...e, item: item })} style={{ marginTop: "6px" }} />
                                                                <Form.Control type='number' style={{ paddingLeft: "2px", height: "27px", fontSize: "12px", marginRight: "6px" }}
                                                                    defaultValue={1} min={1}
                                                                    onChange={(e) => { changeProductCount(item.ID, e); }}
                                                                />
                                                            </InputGroup>
                                                        </td>
                                                    </tr>)
                                            })
                                        }
                                    </tbody>
                                </Table>
                            }
                            {
                                window.innerWidth < 414 &&
                                <div className="mt-2">
                                    {
                                        selectedProductList && selectedProductList === "PENDING" &&
                                        <tr><td colSpan={5 + (pgType !== 1 ? 1 : 0)} style={{ textAlign: "center", width: "100%" }}><Loader width={25} height={25} type="BallTriangle" color="#bb1370" /></td></tr>
                                    }
                                    {selectedProductList && selectedProductList.Error &&
                                        <tr><td colSpan={5 + (pgType !== 1 ? 1 : 0)} style={{ textAlign: "center", color: "red" }}>{selectedProductList.Error}</td></tr>
                                    }
                                    {selectedProductList && Array.isArray(selectedProductList) &&
                                        selectedProductList.map((item, i) =>
                                            <Card key={i} className="mt-1" style={{ boxShadow: "0 0 3px #2e2e6e", paddingTop: 0, borderTop: 0 }}>
                                                <Card.Header style={{ padding: "1px", backgroundColor: i % 2 === 0 ? "#f57bd0" : "#7d7bf5" }}>

                                                </Card.Header>
                                                <Card.Body className="row" style={{ width: "100%", margin: "auto", backgroundColor: i % 2 === 0 ? "#fbf0ff" : "aliceblue", fontSize: "12px", color: i % 2 === 0 ? "#131d7e" : "#7023be" }}>
                                                    <div className="col-12">کالای {item.Name}</div>
                                                    <div className="col-12 mt-1">مدل {item.Model}</div>
                                                    <div className="col-12 mt-1">قیمت واحد: {item.SalePrice?.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</div>
                                                </Card.Body>
                                                <Card.Footer>
                                                    <InputGroup className="mt-0 mb-0" style={{ paddingBottom: 0 }}>
                                                        <input type='checkbox' className='form-check-input' onClick={(e) => select({ ...e, item: item })} style={{ marginTop: "6px" }} />
                                                        <Form.Control type='number' className="showArrows" style={{ marginLeft: "2px", marginRight: "4px", height: "27px", fontSize: "12px" }}
                                                            defaultValue={1} min={1} onChange={(e) => { changeProductCount(item.ID, e); }} onFocus={e => e.target.select()}

                                                        />
                                                        {item.ProductImage && <CardImage onClick={() => magnify(item?.ProductImageURL)} size={18} color="blue" style={{ marginTop: "5px", marginRight: "6px" }} />}
                                                    </InputGroup></Card.Footer>
                                            </Card>
                                        )
                                    }
                                </div>
                            }
                            {submitError?.ProductID && <small className="errors">{submitError.ProductID}</small>}
                            <div className="mt-2" style={{ padding: 0 }}>
                                <Button className='group-Btn-large' variant='info' onClick={add}><CheckSquare />&nbsp; تایید کالاهای انتخاب شده</Button>
                                <Button className='group-Btn-large' variant='danger' onClick={hideAddDiv}><DashCircle />&nbsp;انصراف</Button>
                            </div>
                        </Row>
                    }
                    {!showAddDiv &&
                        <div>
                            <PlusSquareFill size={25} color="#4444cf" className="hoverIcon" style={{ boxShadow: "0 0 3px", borderRadius: "3px" }} onClick={() => setShowAddDiv(true)} />
                        </div>
                    }
                    <Row className="mt-3 rowBorder">
                        <div className="rowTitle">کالاهای انتخاب شده</div>
                        <BihamtaTable columns={tableColes} rowButtons={tableRowButtons} filterData={filterData.current} searchMethod={(data) => dispatch(getCustomerProductList(data))} reducerName="customerDataReducer" objectName="customerProductList" />
                    </Row>
                </Card.Body>
            </Card>
        </div>
    )
}
export default CustomerProducts;